import { FC, ReactNode } from 'react'

import { Dropdown, DropdownOption, DropdownValue } from '@inno-ui/dropdown'
import { Label } from '@inno-ui/label'

import styles from './PreferenceMultiSelectField.module.scss'

type PreferenceMultiSelectFieldProps = {
  label: string
  hint: ReactNode
  items: DropdownOption[]
  values: DropdownOption[]
  onChange: (values: DropdownOption[]) => void
  placeholder?: string
  disabled?: boolean
  isSearchable?: boolean
}

export const PreferenceMultiSelectField: FC<
  PreferenceMultiSelectFieldProps
> = ({
  label,
  hint,
  items,
  values,
  onChange,
  placeholder,
  disabled,
  isSearchable = true
}) => {
  const handleChange = (value: DropdownValue) => {
    onChange(value as DropdownOption[])
  }

  return (
    <div className={styles.preferenceSection}>
      <div className={styles.fieldHeader}>
        <Label label={label} hintZIndex={1001} hint={hint} />
      </div>
      <Dropdown
        items={items}
        value={values}
        onChange={handleChange}
        multiple
        clearable
        isSearchable={isSearchable}
        placeholder={placeholder}
        disabled={disabled}
        width='100%'
      />
    </div>
  )
}
